export default {
  /*
  beforeCreate: function() {
      $.fuiLoader.show()
  },
  */
  created: function () {
    //if (this.config && !this.config.rights) {
      this.$initRights(this.config);
    //}
    const rs = this.config.resource[this.$lan]
    if (rs) this.rs = this.$extend({}, this.$rs, rs)
    else this.rs = this.$rs
    document.title = this.rs.title || this.$rs.defaultTitle
  },
  updated(){
    document.title = this.rs.title || this.$rs.defaultTitle
  },
  data() {
    return {
      detailData: undefined,
      isShowDetail: false,
      detailView: null,
      detailAction: "list",
      detailIndex: 0,
      isNeedReload: false,
      selIdx: undefined,
      rs:null 
    };
  },
  methods: {
    updateIdx(idx){
      this.selIdx = idx
    },
    CFHandler(sfunc, data){
      if (data != undefined) return this[sfunc](data)
      else{
        let row
        if (this.selIdx !=undefined  && this.config.list.length>this.selIdx) row = this.config.list[this.selIdx]
        return this[sfunc](this.selIdx, row)
      }
    },
    getSelRow(){
      if (this.selIdx == undefined) return null
      if (!Array.isArray(this.selIdx)) return this.config.list[this.selIdx]
      else return this.config.list[this.selIdx[0]]
    },
    getSelRows(){
      if (this.selIdx == undefined) return null
      if (!Array.isArray(this.selIdx)) return [this.config.list[this.selIdx]]
      else {
        const tmp=[]
        for (let i=0; i<this.selIdx.length; i++){
          tmp.push(this.config.list[this.selIdx[i]])
        }
        return tmp
      } 
    },
    view(index, el) {
      this.detailView = "detail-panel";
      this.detailAction = "View";
      document.title = this.rs.title? this.rs.title + " - " + this.rs["View"] : this.rs["View"]
      this.detailData = el;
      this.detailIndex = index;
      this.initDetail(el)
    },
    add() {
      this.detailView = "detail-panel";
      this.detailAction = "Add";
      document.title = this.rs.title? this.rs.title + " - "  + this.rs["Add"] : this.rs["Add"]
      this.detailData = {};
      this.detailIndex = -1;
      this.initDetail()
    },
    copy(index, el) {
      this.detailData = el;
      this.detailIndex = index;
      this.detailView = "detail-panel";
      this.detailAction = "Add";
      document.title = this.rs.title? this.rs.title + " - " + this.rs["Copy"] : this.rs["Copy"]
      this.detailIndex = -1;
      this.initDetail(el)
    },
    edit(index, el) {
      this.detailView = "detail-panel";
      this.detailAction = "Edit";
      document.title = this.rs.title? this.rs.title + " - " + this.rs["Edit"] : this.rs["Edit"]
      this.detailData = el;
      this.detailIndex = index;
      this.initDetail(el)
    },
    delete(index, el) {
      if (!this.delConfirm(el)) return 
      const md = this.getDelId(el, this.config.delKeys)
      this.$delAndReload(this.config.url, md, this.config, this.listCallback)
    },
    loadData(page){
      this.$loadData(this.config, page)
    },
    pageSizeChange(ps){
      this.$loadData(this.config, undefined, ps)
    },
    initDetail: function () {
      this.isShowDetail = true;
    },
    openDetail(data){
      if (data && data.rs) {
        this.$extend(this.config, data)
      }
      this.isShowDetail = true;
    },
    back() {
      if (this.isNeedReload){
        this.isNeedReload = false
        this.$loadData(this.config);
      }
      this.isShowDetail = false;
      document.title = this.rs.title || this.$rs.defaultTitle
    },
    exportToPDF() {
      this.$createExport(this.config, "pdf", this.exportCallBack)
    },
    exportToWord() {
      this.$createExport(this.config, "word", this.exportCallBack)
    },
    exportToWord2003() {
      this.$createExport(this.config, "word2003", this.exportCallBack)
    },
    exportToExcel() {
      this.$createExport(this.config, "Excel", this.exportCallBack)
    },
    exportToExcel2003() {
      this.$createExport(this.config, "Excel2003", this.exportCallBack)
    },
    exportCallBack(file, ename){
      window.$fuiDownload(this.$apiUrl + "fm/download?fileName=" + file, ename)
      //window.open(this.$apiUrl + "fm/download?fileName=" + file)
    },
    getDelId(el){
      const dt ={}
      this.config.delKeys.forEach(d=>{
        dt[d]= el[d]
      })
      return dt 
    },
    delConfirm(el){
      const cs = []
      this.config.delConf.forEach(d=>{
        cs.push(el[d])
      })
      return this.$confirm(this.rs["msg_delConf"].replace("{0}", cs.join(",")))
    },
    listCallback(rs){
      if (rs) {
        this.$extend(this.config, rs )
        this.selIdx = undefined
      }
    }
  }
}
